export enum EMapTypes {
  Blank = "Blank",
  Satellite = "Satellite",
  Street = "Street",
  GoogleSatellite = "hybrid",
  GoogleStreet = "roadmap",
  GoogleTerrain = "terrain",
}

export enum EMarkers {
  CameraMarker = "cameraMarker",
  ThreeSixtyMarker = "threeSixtyMarkers",
}

export enum EPageType {
  List = "list",
  Item = "item",
}

export enum EPaths {
  Home = "/",
  Session = "/session",
}

export enum EProjectItems {
  Camera = "camera",
  Overlay = "overlay",
}

export enum ERoles {
  Admin = "admin",
  User = "user",
}
